










import { Component, Vue, Prop } from "vue-property-decorator";
import { GetNoticeResponse } from "@/typescript/api_client/emesh_api/notifications/types";
export { GetNoticeResponse };

@Component
export default class NotificationBarComponent extends Vue {
  @Prop()
  public notification!: GetNoticeResponse;
}
